import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { getOneRosterClass } from "../../../store/OneRoster/OneRosterClassAction";
import StatusCode from "../../../util/StatusCode";
import TableVertical from "../../misc/TableVertical";
import { RequestState } from '../../../models/RequestState';
import { OneRosterClass } from '../../../models/CoreOneRosterModels';
import * as Helper from '../../../util/Helper';
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../store/store";


const OneRosterClassInfo = () => {
    const { t } = useTranslation(['common', 'oneRoster']);

    const { eventId } = useParams();
    const dispatch = useDispatch();
    const classInfo = useSelector<RootState, RequestState<OneRosterClass>>(state => state.onerosterClass.classInfo);

    useEffect(() => {
        if (eventId !== undefined) {
            getOneRosterClass(eventId)(dispatch);
        }
    }, [dispatch, eventId]);

    const renderClassInfo = () => {
        let newList = [];
        if (classInfo.code === StatusCode.COMPLETE) {
            const c = classInfo.data;
            newList.push(
                { header: t('genericTableHeaders.name', { ns: 'common' }), content: c.title },
                { header: t('commonTableHeaders.sisId', { ns: 'oneRoster' }), content: c.id },
                { header: t('commonTableHeaders.status', { ns: 'oneRoster' }), content: t(`statusTypes.${c.status}`, { ns: 'oneRoster' }) },
                { header: t('commonTableHeaders.school', { ns: 'oneRoster' }), content: <Link to={`/oneroster/schoolunit/${c.schoolId}/information`}>{c.schoolName}</Link> },
                { header: t('commonTableHeaders.courseTitle', { ns: 'oneRoster' }), content: c.courseTitle },
                { header: t('genericTableHeaders.created', { ns: 'common' }), content: Helper.formatDate(c.created), classname: 'nowrap' },
                { header: t('genericTableHeaders.modified', { ns: 'common' }), content: Helper.formatDate(c.modified), classname: 'nowrap' },
                { header: t('commonTableHeaders.archived', { ns: 'oneRoster' }), content: Helper.formatDate(c.archived), classname: 'nowrap' },
                { header: t('commonTableHeaders.inactivated', { ns: 'oneRoster' }), content: Helper.formatDate(c.inactivated), classname: 'nowrap' },
            )
        }
        return (
            <TableVertical
                header={t('commonTableHeaders.information', { ns: 'oneRoster' })}
                info={newList}
                error={classInfo.code === StatusCode.ERROR}
                searching={classInfo.code === StatusCode.PENDING}
            />
        )
    }

    const renderAzureInfo = () => {
        let newList = [];
        if (classInfo.code === StatusCode.COMPLETE && classInfo.data.classInfo) {
            const c = classInfo.data.classInfo;
            newList.push(
                { header: t('azureInfo.tableHeaders.objectId', { ns: 'oneRoster' }), content: c.groupId ? <Link to={`https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/${c.groupId}`} target="_blank" >{c.groupId}</Link> : c.groupId },
                { header: t('azureInfo.tableHeaders.isTeam', { ns: 'oneRoster' }), content: Helper.active(c.isTeam), link: c.isTeam ? `https://admin.teams.microsoft.com/teams/manage/${c.groupId}` : null },
                { header: t('azureInfo.tableHeaders.isArchived', { ns: 'oneRoster' }), content: Helper.active(c.isArchived) },
                { header: t('azureInfo.tableHeaders.isPermanentlyDeleted', { ns: 'oneRoster' }), content: Helper.active(c.isPermanentlyDeleted) },
                { header: t('azureInfo.tableHeaders.nextAnalysis', { ns: 'oneRoster' }), content: Helper.formatDate(c.nextAnalysisAt), classname: 'nowrap' },
            )
        }
        return (
            <TableVertical
                header={t('azureInfo.title', { ns: 'oneRoster' })}
                info={newList}
                error={classInfo.code === StatusCode.ERROR}
                searching={classInfo.code === StatusCode.PENDING}
            />
        )
    }

    return (<>
        {renderClassInfo()}
        {renderAzureInfo()}
    </>)
}

export default OneRosterClassInfo;
